import React, { useState, useEffect } from "react";
import Widgets from "../../HomeCards/Card";
import CurrencyFormat from "react-currency-format";
import RequestHandler from "util/RequestHandler";

const DbsNotPaidInvoiceCount = () => {
  const [widgetData, setWidgetData] = useState({
    loading: true,
  });

  useEffect(() => getData(), []);

  const getData = () => {
    RequestHandler.get("/DbsDashboard/NotPaidInvoiceCount").then((response) => {
      setWidgetData({
        data: response.data,
        loading: false,
      });
    });
  };

  return (
    <Widgets
      icon="stats"
      currency={"İleri Vadeli"}
      title="Fatura Adedi"
      totalBalance={
        <CurrencyFormat
          value={widgetData.data}
          displayType={"text"}
          decimalSeparator={","}
          thousandSeparator={"."}
          prefix={""}
        />
      }
    />
  );
};

export default DbsNotPaidInvoiceCount;
